import { useEffect, useRef } from "react";

const AD_CLIENT =
  import.meta.env.VITE_ADSENSE_CLIENT || "ca-pub-9220985750100239";

/**
 * Renders a Google AdSense unit.
 * Set VITE_ADSENSE_SLOT_* in .env to your ad unit slot IDs from AdSense.
 */
export default function AdUnit({
  slot,
  format = "auto",
  className = "",
  label = "Advertisement",
}) {
  const pushed = useRef(false);
  const adSlot = slot || "";

  useEffect(() => {
    if (!adSlot || pushed.current) return;
    pushed.current = true;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      /* AdSense not loaded yet */
    }
  }, [adSlot]);

  if (!adSlot) return null;

  return (
    <div className={["overflow-hidden rounded-lg", className].join(" ")}>
      <p className="text-[10px] uppercase tracking-wider text-white/30 mb-1.5 px-1">
        {label}
      </p>
      <ins
        className="adsbygoogle block"
        style={{ display: "block" }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={adSlot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
